<template>
  <div>
    <v-dialog v-model="status.dialog" persistent max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-list-item class="pl-5" v-on="on" v-bind="attrs">
          <h5 class="title-menu" style="color: black;"> {{ $t('fields.header.profile') }}</h5>
          <v-spacer></v-spacer>
          <v-icon size="20px" color="black">mdi-pencil-outline</v-icon>
        </v-list-item>
      </template>
      <v-card class="card-radius-modal">
        <v-card-title>
          <v-row>
            <v-col class="d-flex justify-center">
                <div class="mx-1 field-custom text-h5">Editar usuario</div>
            </v-col>
            <v-btn icon @click="status.dialog=!status.dialog">
              <v-icon class="text-right" large>icon-cerrar</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <new-user-form
            :status="status"
            :user.sync="user"
            :mode="mode"
            ref="userForm"
            :on-save="update"
            :close="close"
            :load.sync="loading"
          ></new-user-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import NewUserForm from '@/components/NewUserForm'
import FormErrors from '@/mixins/FormErrors'
import Swal from 'sweetalert2'

export default {
  name: 'ProfileModal',
  components: { NewUserForm },
  mixins: [FormErrors],
  data () {
    return {
      show1: false,
      show2: false,
      status: {
        dialog: false
      },
      user: {
        profile_picture: null
      },
      loading: false
    }
  },
  props: {
    item: {},
    mode: String
  },
  computed: {
    userLogged () {
      return this.$store.getters.userLogged
    }
  },
  async created () {
    if (this.mode === 'update') {
      await this.getUser()
    }
  },
  methods: {
    async getUser () {
      const response = await this.$http.get(`${process.env.VUE_APP_API_URL}/clients/${this.userLogged.client_id}/users/${this.userLogged.id}`)
      this.user = response.data
    },
    async update () {
      this.loading = true
      const isValid = await this.$refs.userForm.$refs.userForm.validate()
      if (!isValid) {
        this.loading = false
        return
      }

      try {
        const formData = new FormData()
        formData.append('password', this.user.password)
        formData.append('password_confirmation', this.user.password_confirmation)
        formData.append('profile_picture', this.user.file)
        await this.$http.put(`${process.env.VUE_APP_API_URL}/clients/${this.userLogged.client_id}/users/${this.userLogged.id}`, formData)
        Swal.fire(
          'Updated!',
          'User has been updated.',
          'success'
        )
      } catch (e) {
        this.setErrorsFromServer(e, 'userForm', true)
      } finally {
        this.loading = false
      }
    },
    close () {
      this.status.dialog = false
    }
  }
}
</script>
<style lang="scss">
.field-custom {
  font-size: 15px;
  font-weight: bold;
}

.border-btn {
  border: 2px solid;
}
.title-menu{
  color: #505d69;
  font-weight: normal;
  font-size: 0.9rem;
}

</style>
